const hiddenClass = 'v2-hidden';
export const hideElement = (element:HTMLElement):void => element && element.classList.add(hiddenClass);
export const showElement = (element:HTMLElement):void => element && element.classList.remove(hiddenClass);
